import { genRandomHex } from '@1inch-community/core/random';
export function getNotificationId() {
    return genRandomHex(10);
}
//# sourceMappingURL=notifications-id.js.map